export const STAGES_OPTIONS = [
    { value: "demo", label: "Demo" },
    { value: "trial", label: "Trial / Onboarding ongoing" },
    { value: "onboarding_not_active", label: "Onboarding not active" },
    { value: "onboarding_churn_due", label: "Onboarding Churn / Invoice Due" },
    { value: "onboarding_extended_more_than_30_days", label: "Onboarding extended more than 30 days" },
    { value: "onboarding_redirect_to_sdr", label: "Onboarding redirect to SDR" },
    { value: "onboarding_pause", label: "Onboarding pause" },
    { value: "onboarding_free_plan", label: "Onboarding Free plan" },
    { value: "onboarding_won", label: "Onboarding won" },
    { value: "onboarding_roll_over_the_next_quarter", label: "Onboarding Roll over to next Quater" },
    { value: "onboarding_invoice_raised", label: "Onboarding Invoice Raised" },
    { value: "onboarding_churn", label: "Onboarding churn" },
    { value: "account_management", label: "Account Management" }
];

export const STATUS_OPTIONS = [{ label: "Active", value: "active" }];

export const PLANS_OPTIONS = [
    { label: "Agency", value: "agency" },
    { label: "Pro", value: "pro" },
    { label: "Enterprise", value: "enterprise" }
];

export const PLAN_MAP = {
    agency    : "Agency",
    pro       : "Pro",
    enterprise: "Enterprise"
};

export const STAGE_MAP = {
    demo                 : "Demo",
    onboarding_not_active: "Onboarding not active",
    trial                : "Trial / Onboarding Ongoing",
    onboarding_extended_more_than_30_days:
    "Onboarding extended more than 30 days",
    onboarding_redirect_to_sdr           : "Onboarding redirect to SDR",
    onboarding_invoice_raised            : "Onboarding Invoice Raised",
    onboarding_won                       : "Onboarding Won",
    onboarding_pause                     : "Onboarding Pause",
    onboarding_free_plan                 : "Onboarding Free Plan",
    onboarding_roll_over_the_next_quarter: "Onboarding Roll over to next Quater",
    onboarding_churn_due                 : "Onboarding Churn / Invoice Due",
    onboarding_churn                     : "Onboarding Churn",
    account_management                   : "Account Management"
};

export const STAGE_OPTION = {
    ONBOARDING_ONGOING: "trial",
    ONBOARDING_WON    : "onboarding_won"
};
  